import React from 'react';
import THEME from '../theme.js';
import Badge from './Badge.js';
import File from './File/index.js';
import { ExternalLink } from './Icons/index.js';
import Table from './Table.js';
export const demoEmbeds = {
    // Alm. Brand
    ['e2be6587-e14c-40a8-adca-a6749b225202']: {
        logo: 'https://api.debbiecollect.com/collection-engine/files/55450f19-b502-4e14-8877-7ce0dcfed46f/logo.png',
        table: [
            {
                key: (React.createElement(React.Fragment, null,
                    "Aftale ",
                    React.createElement("small", null, "(download)"))),
                value: (React.createElement(File, { file: {
                        url: 'https://api.debbiecollect.com/collection-engine/files/55450f19-b502-4e14-8877-7ce0dcfed46f/logo.png',
                        fileName: 'Aftale 12322.pdf',
                        contentType: 'application/pdf',
                    } })),
            },
            {
                key: 'Forsikring',
                value: 'Bilforsikring EG49753 Ford 2,0 TDCi Trend 115HK 6g Aut.',
            },
            {
                key: 'Forsikringstype',
                value: 'Kaskoforsikring',
            },
            {
                key: 'Kundenummer',
                value: (React.createElement("a", { target: "_blank", href: 'https://almbrand.dk/entitet/83904856' },
                    "83904856 ",
                    React.createElement(ExternalLink, { style: { margin: '0.1em 0 -0.1em' } }))),
            },
            {
                key: 'Policenummer',
                value: (React.createElement("a", { target: "_blank", href: 'https://almbrand.dk/entitet/9387456454' },
                    "9387456454 ",
                    React.createElement(ExternalLink, { style: { margin: '0.1em 0 -0.1em' } }))),
            },
            {
                key: 'Skadesnummer',
                value: (React.createElement("a", { target: "_blank", href: 'https://almbrand.dk/entitet/7869458656' },
                    "7869458656 ",
                    React.createElement(ExternalLink, { style: { margin: '0.1em 0 -0.1em' } }))),
            },
            {
                key: 'Skadesdato',
                value: (React.createElement(React.Fragment, null,
                    React.createElement(Badge, { theme: THEME.WARNING, style: { float: 'left' } }, "25 m\u00E5neder siden"),
                    "01/01/2023")),
            },
            {
                key: 'Skadested',
                value: 'Nyledsbakken 1, 1725 Kbh V. - Køretøj med reg.nr. AM12345',
            },
            {
                key: 'Reg.nr.',
                value: 'BB92241, KIA',
            },
        ],
    },
    ['ca64eb3c-98d4-4f2a-bdd4-34872468e6a3']: {
        logo: 'https://api.debbiecollect.com/collection-engine/files/af62c5fb-6f4b-4ebc-960b-9b47144d014d/apc_logo.png',
        table: [
            {
                key: (React.createElement(React.Fragment, null,
                    "Pladsnr.",
                    ' ',
                    React.createElement("a", { target: "_blank", href: "https://apcoaflow.apcoa.dk/", rel: "noreferrer" }, "Se plads"))),
                value: '2007',
            },
            {
                key: (React.createElement(React.Fragment, null,
                    "Forseelsessted",
                    ' ',
                    React.createElement("a", { target: "_blank", href: "https://skraafoto.dataforsyningen.dk/?item=2023_82_23_4_0011_00001205&year=2023&center=553234.16%2C6190548.03&item-2=2023_82_23_4_0011_00001205&year-2=2023&orientation=east", rel: "noreferrer" }, "Se skr\u00E5foto"))),
                value: 'Grønlandsvej 2, 8700 Horsens',
            },
            {
                key: 'Gebyr punkt 6',
                value: 'Parkering udenfor afmærket bås',
            },
            {
                key: 'Reg.nr.',
                value: 'BB92241, KIA',
            },
            {
                key: 'Nation',
                value: 'DK',
            },
            {
                key: 'Observationstid på pladsen',
                value: '3 min.',
            },
            {
                key: 'Observationsdato',
                value: '12/01/2023',
            },
            {
                key: 'Observationstid',
                value: (React.createElement(React.Fragment, null,
                    React.createElement(Badge, { theme: THEME.WARNING, style: { float: 'left' } }, "Obs.tid 10 min."),
                    "12:33:43 - 12:43:21")),
            },
        ],
    },
    // Jyske Finans
    ['afd219c4-1fed-4ac9-9fb9-f07b9598a40d']: {
        logo: 'https://api.debbiecollect.com/collection-engine/files/1f8040af-9747-49bd-a38c-933348efa027/logo',
        table: [
            {
                key: 'Kvalificeret misligholdelse',
                value: React.createElement(React.Fragment, null, "25%"),
            },
            {
                key: 'Forsikring',
                value: React.createElement(React.Fragment, null, "TRYG FORSIKRING A/S"),
            },
            {
                key: 'Forsikringsperiode',
                value: (React.createElement(React.Fragment, null,
                    "08-01-2016 - ",
                    React.createElement(Badge, { theme: THEME.WARNING }, "Aktiv"))),
            },
            {
                key: 'Køretøj',
                value: 'Renault, Captur, dCi 90',
            },
        ],
    },
};
const DemoEmbed = (props) => {
    const { logo, table } = props.demoEmbed;
    return (React.createElement("div", { style: { padding: '20px' } },
        React.createElement("img", { src: logo, height: "50", style: { margin: '-10px 0' } }),
        React.createElement("hr", { style: {
                marginTop: '16px',
            } }),
        table && (React.createElement(Table, { zebra: true }, table.map((row) => (React.createElement("tr", { key: row.key },
            React.createElement("td", null, row.key),
            React.createElement("td", { style: { textAlign: 'right' } },
                React.createElement("b", null, row.value)))))))));
};
export default DemoEmbed;
//# sourceMappingURL=EmbedsFrameDemo.js.map